export default {
  getCoaches: (state) => state.coaches,
  getCoachesIsError: (state) => state.status.isError,
  getCoachesError: (state) => state.status.error,
  getCoachesIsLoading: (state) => state.status.isLoading
};
